import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { CustomerModel } from './models/customer';

@Component({
  selector   : 'wor-change-customer',
  template: require('./customer.change.component.html')
})
export class ChangeCustomerComponent {
  @Input() customer: CustomerModel;

  selectedCustomer: CustomerModel | null = null;

  constructor (
    public activeModal: NgbActiveModal
  ) {}

  confirm () : void {
    if ( this.selectedCustomer?.id ) {
      this.activeModal.close(this.selectedCustomer);
    }
  }
}
